import { useCallback, useEffect, useRef, useState } from 'react';
import { getCatalog, getCategory } from '../../api/catalog';
import { getSummary, getTopProducts, getTimeline, getByCategory, csvUrl } from '../../api/admin/reports';
import './AdminReports.css';

export default function AdminReports() {
  const [filters, setFilters] = useState({ from: '', to: '', topCategorySlug: '', subcategoryId: '' });
  const [catalog, setCatalog] = useState([]);
  const [subcats, setSubcats] = useState([]);

  const [summary, setSummary] = useState(null);
  const [top, setTop] = useState([]);
  const [timeline, setTime] = useState([]);
  const [byCat, setByCat] = useState([]);

  const filtersRef = useRef(filters);
  useEffect(() => { filtersRef.current = filters; }, [filters]);

  const load = useCallback(async () => {
    const params = { ...filtersRef.current };
    const [s, t, tl, bc] = await Promise.all([
      getSummary(params),
      getTopProducts({ ...params, limit: 20 }),
      getTimeline(params),
      getByCategory(params),
    ]);
    setSummary(s); setTop(t); setTime(tl); setByCat(bc);
  }, []);

  const init = useCallback(async () => {
    const cats = await getCatalog();
    setCatalog(cats || []);
    await load();
  }, [load]);

  useEffect(() => { init(); }, [init]);

  async function onCatChange(e) {
    const slug = e.target.value;
    setFilters(f => ({ ...f, topCategorySlug: slug, subcategoryId: '' }));
    if (!slug) return setSubcats([]);
    const cat = await getCategory(slug);
    setSubcats(cat?.subcategories || []);
  }
  function onChange(e){ setFilters({ ...filters, [e.target.name]: e.target.value }); }

  return (
    <div className="reports">
      <h2 className="admin-page-title">Отчёты по продажам</h2>

      <div className="filters">
        <input className="fld" type="date" name="from" value={filters.from} onChange={onChange}/>
        <input className="fld" type="date" name="to"   value={filters.to}   onChange={onChange}/>
        <select className="fld" name="topCategorySlug" value={filters.topCategorySlug} onChange={onCatChange}>
          <option value="">Все категории</option>
          {catalog.map(c => <option key={c._id} value={c.slug}>{c.name?.ru || c.slug}</option>)}
        </select>
        <select className="fld" name="subcategoryId" value={filters.subcategoryId} onChange={onChange} disabled={!subcats.length}>
          <option value="">Все подкатегории</option>
          {subcats.map(s => <option key={s._id} value={s._id}>{s.name?.ru || s.slug}</option>)}
        </select>
        <button className="admin-btn" onClick={load}>Показать</button>
      </div>

      {summary && (
        <div className="kpi">
          <div className="k"><div className="k-name">Выручка</div><div className="k-val">{summary.revenue} ₽</div></div>
          <div className="k"><div className="k-name">Себестоимость</div><div className="k-val">{summary.cost} ₽</div></div>
          <div className="k"><div className="k-name">Маржа</div><div className="k-val">{summary.grossProfit} ₽</div></div>
          <div className="k"><div className="k-name">Штук</div><div className="k-val">{summary.itemsQty}</div></div>
          <div className="k"><div className="k-name">Чеков</div><div className="k-val">{summary.checks}</div></div>
        </div>
      )}

      <div className="block">
        <div className="block-head">
          <h3>Топ товаров</h3>
          <a className="link" href={csvUrl('top-products', filters)}>CSV</a>
        </div>
        <table className="table">
          <thead><tr><th>Товар</th><th>Штук</th><th>Выручка</th><th>Себестоимость</th><th>Маржа</th><th>Средняя цена</th></tr></thead>
          <tbody>
            {top.map(r=>(
              <tr key={r._id}>
                <td>{r.title}</td>
                <td>{r.qty}</td>
                <td>{r.revenue}</td>
                <td>{r.cost}</td>
                <td>{r.grossProfit}</td>
                <td>{Math.round(r.avgPrice)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="block">
        <div className="block-head">
          <h3>Динамика по дням</h3>
          <a className="link" href={csvUrl('timeline', filters)}>CSV</a>
        </div>
        <table className="table">
          <thead><tr><th>Дата</th><th>Штук</th><th>Выручка</th><th>Себестоимость</th><th>Маржа</th></tr></thead>
        <tbody>
          {timeline.map(r=>(
            <tr key={r.date}>
              <td>{r.date}</td><td>{r.qty}</td><td>{r.revenue}</td><td>{r.cost}</td><td>{r.grossProfit}</td>
            </tr>
          ))}
        </tbody>
        </table>
      </div>

      <div className="block">
        <div className="block-head">
          <h3>По категориям</h3>
          <a className="link" href={csvUrl('by-category', filters)}>CSV</a>
        </div>
        <table className="table">
          <thead><tr><th>Категория</th><th>Подкатегория</th><th>Штук</th><th>Выручка</th><th>Себестоимость</th><th>Маржа</th></tr></thead>
          <tbody>
            {byCat.map(r=>(
              <tr key={`${r.topCategorySlug}-${r.subcategoryId || 'none'}`}>
                <td>{r.categoryName || r.topCategorySlug}</td>
                <td>{r.subcategoryName || '—'}</td>
                <td>{r.qty}</td><td>{r.revenue}</td><td>{r.cost}</td><td>{r.grossProfit}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
